/**
 * 이모 수첩 지우기 · 되돌리기 (시안 04 D2b). 지우기는 한 번 더 묻지 않고 화면에서 바로 빼고, 5초 동안
 * 「지웠어요 · 되돌리기」 토스트를 띄웁니다. 5초가 지나면 그때 서버에 지웁니다(README 7.2: 클라이언트에서 보류).
 * 고친 문장은 같은 가게(store)로 알려, 열려 있는 수첩 화면과 대화 안 줄이 같은 글을 보게 합니다.
 */
import { create } from 'zustand';
import * as meApi from '../api/me.js';

export const UNDO_MS = 5000;

export const useMemoBook = create((set, get) => ({
    // 지우기를 기다리는 줄 id (화면에서 숨김)
    hiddenIds: [],
    // 고친 문장 id → text (화면에 바로 반영)
    editedText: {},
    toast: null,
    timer: null,

    noteEdited(memoriesId, text) {
        set({ editedText: { ...get().editedText, [memoriesId]: text } });
    },

    /** 화면에서 빼고 5초 뒤 서버에 지웁니다. 그사이 되돌리면 그대로 */
    deleteWithUndo(memory) {
        get().flush();
        const timer = setTimeout(() => {
            get().flush();
        }, UNDO_MS);
        set({ hiddenIds: [...get().hiddenIds, memory.memoriesId], toast: { memory }, timer });
    },

    undo() {
        const { toast, timer } = get();
        clearTimeout(timer);
        if (toast) {
            set({ hiddenIds: get().hiddenIds.filter((id) => id !== toast.memory.memoriesId) });
        }
        set({ toast: null, timer: null });
    },

    /** 기다리던 지우기를 지금 보냅니다(다음 지우기가 오거나 5초가 지났을 때) */
    async flush() {
        const { toast, timer } = get();
        clearTimeout(timer);
        set({ toast: null, timer: null });
        if (!toast) {
            return;
        }
        try {
            await meApi.deleteMemory(toast.memory.memoriesId);
        } catch {
            // 못 지웠으면 다시 보입니다
            set({ hiddenIds: get().hiddenIds.filter((id) => id !== toast.memory.memoriesId) });
        }
    },
}));
